<template>
    <section class="relative">
        <background />
        <container class="contact">
            <h1> Contact Us </h1>
            <row v-if="!emailSent">
                <column class="dark" :width="1/3">
                    <p> 72 Kembla St Fyshwick 2609 </p>
                    <p> 1300 360 961  </p>
                </column>
                <column class="light" :width="2/3">
                    <h4> Your Name </h4>
                    <input type="text" v-model="name" />
                    <h4> Your Email </h4>
                    <input type="text" v-model="email" />
                    <h4> Subject </h4>
                    <input type="text" v-model="subject" />
                    <h4> Your Message </h4>
                    <textarea  v-model="message"/>
                    <spacer />
                    <row :justify="'center'" :align="'center'" class="light">
                        <vue-recaptcha class="captcha" :sitekey="sitekey" @verify="setResponse">
                        </vue-recaptcha>
                        <button v-if="this.name && this.subject && this.message && this.email.match(this.mailFormat) && this.response" @click="sendMail()"> Send </button>
                        <div v-else class="fake-button"> Send </div>
                    </row>
                </column>
            </row>
            <div class="dark">
                <h2 v-if="emailSent"> Email Sent! </h2>
            </div>
        </container>
        <spacer />
    </section>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
export default {
    name: 'contact',
    data () {
        return {
            name: '',
            email: '',
            subject: '',
            message: '',
            emailSent: false,
            sitekey: process.env.VUE_APP_SITE,
            response: '',
            mailFormat: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
        }
    },
    components: {
        VueRecaptcha
    },
    methods: {
        setResponse(response) {
            this.response = response;
        },
        async sendMail () {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 
                    response: this.response,
                    mail: {
                        subject: this.subject, message: this.message, email: this.email
                    },
                    site: 'mitservices'
                })
            }
            this.emailSent = await fetch('https://mailcaptcha.mitservices.com.au/api', requestOptions).then(res => {
                console.log(res);
                return res.status === 200
            });
            if (this.emailSent) {
                alert('Email Sent!');
            } else {
                alert('Captcha Failed');
            }
        }
    }
}
</script>

<style scoped>
    section {
        display: inline-block;
        width: 100%;
    }
    .background {
        background-image: url('../assets/background/network.jpg');
    }
    .row {
        align-items: center;
        justify-items:end;
        background-color: rgb(40, 40, 40);
    }
    .light {
        background-color: rgb(200,200,200);
        color: rgb(40, 40, 40);
        padding-bottom: 10px;
    }
    input {
        text-align: center;
    }
    input, textarea {
        margin-left: 10px;
        margin-right: 10px;
    }
    button, .fake-button, .captcha {
        margin: 0.5em auto;
        font-size: 2em;
    }
    .captcha {
        width: 304px;
    }
    .fake-button {
        background-color: rgb(73, 73, 73);
        color: rgb(112, 112, 112);
        width: 3em;
    }
    button {
        background-color: rgb(40, 36, 36);
        color: white;
        width: 3em;
        transition: 0.3s;
    }
    button:hover {
        color: black;
        background-color: rgb(245, 102, 55);
    }
</style>
